import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getMasterBook = async (id) => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      `ticket-detail/?id=${id}`,
      {},
      false,
      null,
      "Migrated"
    );
    console.log("getMasterBook response.data :>> ", response.data);

    // 複数画面で使うため、storeにセット
    store.commit("ticketing/setMasterBook", response.data);
    return response.data;
  } catch (err) {
    console.log('ERROR"" getMasterBook():', err);
    throw err;
  }
};
